<template>
  <RouterView />
</template>

<script setup lang="ts">
import { watch } from 'vue'
import type { RouteLocationNormalizedLoaded } from 'vue-router'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { applySeo, buildSeoByRoute } from './services/seo'
import { applyDocumentDirection, normalizeAppLocale } from './utils/locale'

const route = useRoute()
const router = useRouter()
const { locale } = useI18n()

/** Prefer leaf route name so title matches the visible page after navigation resolves. */
function resolveRouteName(r: RouteLocationNormalizedLoaded): string {
  if (typeof r.name === 'string') return r.name
  const last = r.matched[r.matched.length - 1]
  if (last && typeof last.name === 'string') return last.name
  return 'home'
}

function runSeo(r: RouteLocationNormalizedLoaded) {
  const localeValue = normalizeAppLocale(locale.value)
  applyDocumentDirection(localeValue)
  const routeName = resolveRouteName(r)
  const country = typeof r.params.country === 'string' ? r.params.country : undefined
  const path = r.path || '/'
  applySeo(buildSeoByRoute(routeName, path, localeValue, country), localeValue)
}

router.afterEach((to) => {
  runSeo(to)
})

watch(locale, () => runSeo(route), { flush: 'post' })
</script>

<style lang="scss">
#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
}
</style>
